import { render } from "./FemaleUsers.vue?vue&type=template&id=3389baa4&scoped=true"
import script from "./FemaleUsers.vue?vue&type=script&lang=js"
export * from "./FemaleUsers.vue?vue&type=script&lang=js"

import "./FemaleUsers.vue?vue&type=style&index=0&id=3389baa4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3389baa4"

export default script